import React, { useContext } from "react";
import "./app.css";
import Home from "./components/home/Home";
import Menu from "./components/menu bar/Menu";
import Skills from "./components/skills/Skills";
import Projects from "./components/projects/Projects";
import Resume from "./components/resume/Resume";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import { ModeContext } from "./components/utils/modes-context";

const App = () => {
  const { darkMode } = useContext(ModeContext);

  return (
    <div className={darkMode ? "" : "body_lightmode"}>
      <Home />
      <Menu />
      <Skills />
      <Resume />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
};

export default App;
